export default function marquee() {
  var speed = 60;
  var gap = 50;

  if ($(window).width() < 768) {
    speed = 40;
    gap = 15;
  } else if ($(window).width() < 992) {
    speed = 50;
    gap = 30;
  }

	$('.marquee-heading').each(function(){
    $(this).marquee({
      speed: speed,
      gap: gap,
      duplicated: true,
      delayBeforeStart: 0,
      startVisible: true,
      direction: 'left',
    });
  });
}